// 组件对象，大写
import auditComent from './auditComent.vue'
export default auditComent
